import { useIsNavigatingBack as v } from "../contexts/global-context.js";
const e = {
  delay: 0,
  whileInView: !1,
  duration: void 0,
  easing: void 0
}, s = {
  alwaysAnimate: !1,
  blockIndex: void 0
}, c = (i, n, a) => {
  const { delay: t, whileInView: m, duration: r, easing: d, displayAmountTreshold: l } = i.config, { alwaysAnimate: u, blockIndex: y } = i.conditions;
  if (v() && !u)
    return;
  const o = m && y !== 0;
  return {
    initial: n,
    transition: {
      delay: t,
      duration: r,
      ease: d
    },
    whileInView: o ? a : void 0,
    animate: o ? void 0 : a,
    viewport: o ? { once: !0, amount: l ?? 0.25 } : void 0
  };
}, T = (i = e, n = s) => c({ config: i, conditions: n }, {
  opacity: 0,
  y: 20
}, {
  opacity: 1,
  y: 0
}), g = (i = e, n = s) => c({ config: i, conditions: n }, {
  y: 20
}, {
  y: 0
}), F = (i = e, n = s) => c({ config: i, conditions: n }, {
  opacity: 0
}, {
  opacity: 1
});
export {
  F as useAnimateFadeIn,
  T as useAnimateFadeInToTop,
  g as useAnimateSlideToTop
};
